<template>
  <div>
    <div class="page-title">Edit Presentation</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Presentation"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.presentations.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Presentation.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.Presentation.update(this.form);
      this.$router.push("/dev-tools/presentations");
    },
  },
};
</script>

<style></style>
